import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import MuiChip from '@mui/material/Chip';
import MuiContainer from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

export const BankCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: theme.spacing(9),
  margin: theme.spacing(8, 0),
  minHeight: 190,
  boxSizing: 'border-box',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: 8,
  '&:hover': {
    backgroundColor: theme.palette.blue10.main,
  },
  '&:hover div[data-element="best-offer-headline"]': {
    backgroundColor: theme.palette.blue60.main,
    color: theme.palette.white.main,
  },

  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(5, 1.5, 6, 1.5),
  },
}));

export const BankDetails = styled('div')(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(0, 3),
  },
}));

export const BankTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.black80.main,
  textAlign: 'left',
  fontWeight: theme.typography.body1.fontWeight,

  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.h3.fontSize,
    lineHeight: theme.typography.h3.lineHeight,
  },
}));

export const CustomLink = styled('a')({
  textAlign: 'unset',
  textDecoration: 'none',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const TooltipContent = styled('div')({
  display: 'inline-block',
});

export const Chip = styled(MuiChip)({
  height: 22,
  cursor: 'pointer',
});

export const BenefitsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const Container = styled(MuiContainer)({
  padding: 0,
});

export const BankListContainer = styled(MuiContainer)(({ theme }) => ({
  padding: 0,
  margin: theme.spacing(14, 'auto'),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(0, 6),
  },
}));

export const DetailsContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}));

export const DetailItem = styled('div')(() => ({
  width: '100%',
}));

export const PromotedProduct = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  marginTop: theme.spacing(2),
}));
